var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('enrollment-header'),_c('enrollment-navigation-drawer',{attrs:{"items":_vm.items}}),_c('v-main',{staticClass:"pl-1 pt-3"},[_c('router-view')],1),_c('enrollment-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }